module.exports = __webpack_public_path__ + "static/media/delete-icon.a679785a.svg";